module.exports = __webpack_public_path__ + "static/media/lexus.fcd20fce.png";